import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HighchartsPie, { defaultOptions } from '../graph/HighchartsPie';
import FlexTable from '../table/FlexTable';
import HeaderComponent from '../HeaderComponent';
import LoadMore from '../LoadMore';

import { formatNumber, formatLargeNumber } from '../../service/market';

import table from '../../styles/table/flextable';
import css from '../../styles/instrument/owners';

class Owners extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        CHANGE_PCT: PropTypes.number,
        TOP_TOTAL: PropTypes.number,
        TOP_POSITION_TIME: PropTypes.number,
        TOP_INVESTOR_1: PropTypes.string,
        TOP_INVESTOR_2: PropTypes.string,
        TOP_INVESTOR_3: PropTypes.string,
        TOP_INVESTOR_4: PropTypes.string,
        TOP_INVESTOR_5: PropTypes.string,
        TOP_INVESTOR_6: PropTypes.string,
        TOP_INVESTOR_7: PropTypes.string,
        TOP_INVESTOR_8: PropTypes.string,
        TOP_INVESTOR_9: PropTypes.string,
        TOP_INVESTOR_10: PropTypes.string,
        TOP_POSITION_SHARES_1: PropTypes.number,
        TOP_POSITION_SHARES_2: PropTypes.number,
        TOP_POSITION_SHARES_3: PropTypes.number,
        TOP_POSITION_SHARES_4: PropTypes.number,
        TOP_POSITION_SHARES_5: PropTypes.number,
        TOP_POSITION_SHARES_6: PropTypes.number,
        TOP_POSITION_SHARES_7: PropTypes.number,
        TOP_POSITION_SHARES_8: PropTypes.number,
        TOP_POSITION_SHARES_9: PropTypes.number,
        TOP_POSITION_SHARES_10: PropTypes.number,
        TOP_INVESTOR_ACCOUNT_TYPE_1: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_2: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_3: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_4: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_5: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_6: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_7: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_8: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_9: PropTypes.string,
        TOP_INVESTOR_ACCOUNT_TYPE_10: PropTypes.string,
    }

    constructor(props) {
        super(props);

        this.state = {
            showAll: false,
            data: [],
        };

        this.colors = [
            '#DCD5CD',
            '#48A2D3',
            '#4DC9A4',
            '#EF9E4E',
            '#D55F8D',
            '#945CD3',
            '#96D470',
            '#F3D339',
            '#8DA39D',
            '#EB6453',
            '#C29559',
        ];

        this._getSum = (propsObj = this.props) => [
            propsObj.TOP_POSITION_SHARES_1, propsObj.TOP_POSITION_SHARES_2,
            propsObj.TOP_POSITION_SHARES_3, propsObj.TOP_POSITION_SHARES_4,
            propsObj.TOP_POSITION_SHARES_5, propsObj.TOP_POSITION_SHARES_6,
            propsObj.TOP_POSITION_SHARES_7, propsObj.TOP_POSITION_SHARES_8,
            propsObj.TOP_POSITION_SHARES_9, propsObj.TOP_POSITION_SHARES_10,
        ].reduce((a, b) => a + b);

        this._showAll = () => this.setState({ showAll: true });

        this._getProp = (propsObj, prop, index) => propsObj[`${prop}_${index}`];
    }

    componentDidMount() {
        this.setData();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.data.length) {
            if (nextProps.TOP_TOTAL) {
                this.setData(nextProps);
            }
        }
    }

    setData(nextProps = null) {
        const props = nextProps !== null ? nextProps : this.props;
        const { TOP_TOTAL } = props;

        if (!TOP_TOTAL) return;

        const data = [];

        for (let i = 1; i < 11; i++) {
            data.push({
                name: this._getProp(props, 'TOP_INVESTOR', i),
                y: this._getProp(props, 'TOP_POSITION_SHARES', i) || '',
                color: this.colors[i],
            });
        }

        data.push({
            name: 'Resterende eiere',
            y: TOP_TOTAL - this._getSum(props),
            color: this.colors[0],
        });

        this.setState({ data });
    }

    renderFields() {
        const { TOP_TOTAL } = this.props;

        const rows = [];

        const limit = this.state.showAll ? 11 : 6;

        for (let i = 1; i < limit; i++) {
            const shares = this._getProp(this.props, 'TOP_POSITION_SHARES', i);
            const share = formatNumber((shares / TOP_TOTAL) * 100, 1);

            const ballStyle = { backgroundColor: this.colors[i] };

            rows.push(
                <div className={table.tableRow} key={i}>
                    <div className={`${table.tableCell} ${table.ellipsis}`}>
                        <div className={css.ball} style={ballStyle} />
                        {this._getProp(this.props, 'TOP_INVESTOR', i)}
                    </div>
                    <div className={table.tableCell}>{formatLargeNumber(shares, 1)}</div>
                    <div className={[table.tableCell, table.sharePercent].join(' ')}>{share}%</div>
                </div>
            );
        }

        return rows;
    }

    renderPieChart() {
        if (!this.state.data.length) return null;

        const config = Object.assign({}, defaultOptions, { series: [{ data: this.state.data }] });

        return (
            <HighchartsPie
                className={css.graph}
                config={config}
                data={this.state.data}
                ref={(node) => { if (node) this.chart = node.getWrappedInstance();}}
            />);
    }

    render() {
        if (!this.props.TOP_INVESTOR_1) {
            return null;
        }

        const headings = [
            'TOP_INVESTOR',
            'TOP_POSITION_SHARES',
            'TOP_POSITION_SHARES_PCT',
        ];

        return (
            <HeaderComponent title={this.props.t('largestInvestors')}>
                <div className={css.pieChart}>
                    {this.renderPieChart()}
                </div>
                <div className={css.tableWrapper}>
                    <FlexTable columns={headings}>
                        {this.renderFields()}
                    </FlexTable>
                    {!this.state.showAll && <div className={css.loadWrapper}>
                        <LoadMore
                            onClick={this._showAll}
                        />
                    </div>}
                </div>
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Owners);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Owners.js
 **/